import { render, staticRenderFns } from "./FavouritesCompetitionSmallDeatails.vue?vue&type=template&id=58de9142&scoped=true"
import script from "./FavouritesCompetitionSmallDeatails.vue?vue&type=script&lang=js"
export * from "./FavouritesCompetitionSmallDeatails.vue?vue&type=script&lang=js"
import style0 from "./FavouritesCompetitionSmallDeatails.vue?vue&type=style&index=0&id=58de9142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58de9142",
  null
  
)

export default component.exports